export default class NativeCopyToClipboardNotImplementedError extends Error {
  constructor() {
    super('Native copy to clipboard not implemented');
  }
}
